import React, { useState } from "react";
import { Box, Paper } from "@mui/material";
import useModeColor, { TMode } from "../../hooks/useModeColor";
import { IconSets, TIconSetName } from "./IconSets";
import ToggleIcon from "../../Components/ToggleIcon";

const ToggleIconSetPreview = (props: { icon_set_name: TIconSetName }) => {
  const { icon_set_name } = props;
  const [mode, setMode] = useState<TMode>("on");
  const iconName =
    mode === "on" ? IconSets[icon_set_name].on : IconSets[icon_set_name].off;
  const iconColor = useModeColor(mode);
  const toggle = () => setMode(mode === "on" ? "off" : "on");

  return (
    <Paper
      sx={{
        bgcolor: `${mode}.main`,
        color: `${mode}.text`,
      }}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width={54}
        height={54}
      >
        <ToggleIcon name={iconName} color={iconColor} onClick={toggle} />
      </Box>
    </Paper>
  );
};

export default ToggleIconSetPreview;
